// ================================ cart-page-ajax =====================================
$(function() {

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  function ajaxSubmitCart() {
    $cart = $("#cart_form");
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        //JSON.stringify(data);
        refreshCart(data);           
      }    
      
    });
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  
   
     // refreshCart(cart);
      ajaxSubmitCart();
      //alert()
  

//   function selectbar(cart) {
//     alert(cart.item.title);
//   }
 
	//var x = $('.additional-checkout-buttons').html();
  
//  Age restict popup 
  function ageRestrictMsg(){
      setTimeout(function(){   
        $( ".action_button" ).click(function() {
          $(".mask-quick").addClass("mask-quick-div");
          $("body").addClass("mask-quick-add");
        });
        $( ".return-btn" ).click(function() {
          $(".mask-quick").removeClass("mask-quick-div");
          $("body").removeClass("mask-quick-add");
        });
      }, 1500);
  }

    function refreshCart(cart) {
    $cartBtn = $(".icon-cart");
    if ($cartBtn && $cartBtn.size()) {
      var value = $cartBtn.text() || '0';
      var cart_items_html = "";
      var $cart = $("#cart_form ul.grid-item");
      
      //$cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
      $cart.find('li:not(:first)').remove();

      if (cart.item_count == 0) {        
       
      } else {
                    
         var totalQty = 0;
        
        $.each(cart.items, function(index, item) {          
                    cart_items_html += '<li class="cart_item  grid-item one-whole">' +
            '<a href="' + item.url +'">';
          if (item.image) {
            cart_items_html += '<div class="cart_image grid-item one-third large--one-sixth">' +
                '<img src="' + item.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
              '</div>';
          }
          cart_items_html += '<div class="item_title grid-item two-thirds large--four-tenths">' +
            '<span>' + item.title +'</span>' +            
            //'<strong class="price">' + item.price + '</strong>' +
            '</div>'+
             // '<strong class="price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</strong>' +
            '</a>' +
            '<p class="mm-counter grid-item one-fifth medium-down--one-third">' +   
            '<span class="qty-box">' +
              '<span class="ss-icon minus '+ item.product_type +'">-</span>' +
              '<input type="text" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'"  readonly="readonly" />' +
              '<span class="ss-icon plus '+ item.product_type +' ">+</span>' +  
            '</span>' +
            '</p>' +
              '<p class="line_price grid-item one-eighth medium-down--one-third medium-down--text-left text-right">' +
              '<strong class="price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</strong>' +
              '</p>' +
            '<p class="remove-icon grid-item one-tenth medium-down--one-third text-right">'+
            '<a href="/cart/change?line='+ (index+1) +'&amp;quantity=0" data-line="'+ (index+1) +'" class="icon-fallback-text btn-secondary remove">' +
            '<span class="icon icon-x" aria-hidden="true"></span>'+
              '<span class="fallback-text">Remove</span>'+
            '</a>' +
              '</p>' +
          '</li>';
          
          
          var prodtype = item.product_type;
          var str2 = 'Wine';
          if(prodtype.indexOf(str2) != -1){
            totalQty = totalQty + item.quantity;
          }
          
          
        });
        cart_items_html += '<li class="cart_item grid-item mm-label text-right">' +
          '<div class="cart-subtotal">' +
          'subtotal'+
            '<p class="h1 cart-subtotal--price">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) +'</p>' +
          	//'<p class="mm-counter">' +  cart.total_price + '</p>' +
          '</div>' +
          '</li>';
   
        
        cart_items_html += '<li class="mm-subtitle button-section text-right">';

           
            cart_items_html += '<div class="grid-item large--one-half">' +
        '<label for="cartSpecialInstructions">Tell us about any special instructions: </label>' +
        '<textarea name="note" class="input-full" id="cartSpecialInstructions"></textarea>'+
      '</div>' ;
          

          
          cart_items_html += '<p class="cart-subtotal__note"><em>Shipping, taxes, and discounts will be calculated at checkout.</em></p>' +
            '<p class="checkout-btn action_button btn right button hover-shadow pre_checkout"> Checkout Securely <span class="icon-lock"><svg viewBox="0 0 14 19" id="locker" width="18px" height="18px"><title>noun_9362</title><path d="M12.056 7.958h-.58V4.283C11.475 2.197 9.467.5 7 .5S2.524 2.197 2.524 4.283v3.675h-.58C1.15 7.958.5 8.605.5 9.396v7.666c0 .79.65 1.438 1.444 1.438h10.112c.794 0 1.444-.647 1.444-1.438V9.396c0-.79-.65-1.438-1.444-1.438zM8.26 15.945H5.74l.51-2.704A1.447 1.447 0 0 1 7 10.55a1.447 1.447 0 0 1 .75 2.692l.51 2.703zm1.297-7.987H4.443V4.283C4.443 3.268 5.613 2.41 7 2.41c1.386 0 2.557.858 2.557 1.873v3.675z" fill="#FFF" fill-rule="nonzero"></path></svg></span> </p>' +
          '</li>';
       
        var moduloQty = totalQty % 6;
        var button = $('.button-section');
  
        if(moduloQty == 0){
          var moduloQty = moduloQty;
          $('.cart-warning').addClass('hide');                       
          $('.mm-label').before(button);
		  for(var i = 0; i < 6; ++i){
            var cnt1 = "fill-"+ i;
            $('.bottle-count').eq(i).removeClass(cnt1);
           //for checkout popup              
            $('.fill-mini-bottle').eq(i).removeClass(cnt1);   
            $('.pre_checkout_wrapper').hide();
          }          
        }else{
          $('.cart-warning').removeClass('hide');
          $('.pre_checkout_wrapper').show();
          setTimeout(function(){
            $('.button-section').remove();   
          }, 10); 
        }
        var subtraction = totalQty % (6);
        var subtraction = 6 - subtraction;
        var bottlecount = 6 - subtraction;
        $('.bottle-note').find('b').find('span').html(subtraction);
        for(var i = 0; i < 6; ++i){
          var classhb = (i < bottlecount)?i:'';        
          var removebottle = bottlecount;    
          var cnt1 = "fill-"+removebottle;
          var cnt = "fill-"+classhb;
          //alert(removebottle);
          //alert(cnt1);
          $('.bottle-count').eq(classhb).addClass(cnt); 
          $('.bottle-count').eq(removebottle).removeClass(cnt1); 
          $('.fill-mini-bottle').eq(classhb).addClass(cnt); 
          $('.fill-mini-bottle').eq(removebottle).removeClass(cnt1); 
           
        }  
            
        $cart.append(cart_items_html);
        $cart.find('li.cart_item:last').addClass('last_cart_item');

          if($('.currencies:visible option:selected').val()) {
            //alert();
            Currency.convertAll($cart.data('shop-currency'), $('.currencies:visible option:selected').val()); 
          }    
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      }
    }
      ageRestrictMsg();
  }

  $(document).on("change", "#cart input.quantity", function() { 
    ajaxSubmitCart();  
    ageRestrictMsg();
    
  });

  $(document).on("click", ".minus", function() {    
    var quantity = parseInt($(this).parents(".mm-counter").find("input").val()); 
    if ($(this).hasClass('Wine')) {
      quantity -= 6;
    }else{
      quantity -= 1;
    }
    $(this).parents(".mm-counter").find("input").attr("value", quantity);
    
    if (quantity == 0) {
//       $(this).closest('li.cart_item').addClass('animated fadeOutUp')
      setTimeout(ajaxSubmitCart, 500);
     // window.document.location.reload(true);
       //window.location.replace("//winedealsdirect.co.uk/cart");
      setTimeout(function(){
     window.location.replace("//winedealdirect.co.uk/cart");
        }, 600);
    } else {    
      ajaxSubmitCart();
      ageRestrictMsg();
    }
  });
  $(document).on("click", ".plus", function() { 
    var quantity = parseInt($(this).parents(".mm-counter").find("input").val()); 
    if ($(this).hasClass('Wine')) {
      quantity += 6;
    }else{
      quantity += 1;
    }    
    $(this).parents(".mm-counter").find("input").attr("value", quantity);
    ajaxSubmitCart();
    ageRestrictMsg(); 
  });
  
  
$( document ).ready(function() {
  
  ageRestrictMsg(); 
  
  setTimeout(function(){
  $( ".plus,.minus" ).click(function() {
	$(".icon-cart").eq(0).addClass("add-img");
  });
   }, 300); 
});
        
});

function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }
}


$( document ).ready(function() {
  
  $(".bottle-icon").clone(true, true).contents().appendTo('.cart-bottle');
  $('.cart-bottle .bottle-count').addClass('fill-mini-bottle');
     
    $( ".pre_checkout" ).click(function() {
      $(".cart-main").addClass("cart-modal");
      $("body").addClass("cart-modal-open");
    });
    $( ".return-btn" ).click(function() {
      $(".cart-main").removeClass("cart-modal");
      $("body").removeClass("cart-modal-open");
    });
  
});
     
      